<template>
  <vx-card :title="$t(`DATASOURCEVIEW.uploadmasive`)">
    <span>{{ $t(`DATASOURCEVIEW.uploadFileOriginData`) }}</span>

    <!-- Info -->
    <vs-input
      class="w-full mb-base"
      :label-placeholder="$t(`DATASOURCEVIEW.description`)"
      v-model.trim="description"
    ></vs-input>

    <vs-alert color="primary" icon="new_releases" active="true" class="mt-5">
      <span v-html="$t(`DATASOURCEVIEW.charactersSpecials`)"></span>
    </vs-alert>

    <div class="demo-alignment">
      <input type="file" id="file" ref="file" placeholder="Search" class="is-label-placeholder" />
    </div>

    <vs-row>
      <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
        <vs-button class="ml-3 hidden lg:inline-block w-1/3" color="success" type="border" @click="previewFiles()">
          Cargar origen</vs-button
        >
      </vs-col>
    </vs-row>
  </vx-card>
</template>

<script>
import Api from "@/helpers/api";

export default {
  data() {
    return {
      file: undefined,
      description: null
    };
  },
  methods: {
    previewFiles() {
      if (
        this.description === undefined ||
        this.description === null ||
        this.description === "" ||
        this.description.length === 0
      ) {
        return this.$vs.notify({
          title: "Origenes de datos",
          text: "Agregue una descripción al archivo",
          iconPack: "feather",
          icon: "icon-bell",
          color: "warning"
        });
      }
      console.log("this.$refs.file ", this.$refs.file.files.length);
      if (this.$refs.file.files.length === 0) {
        return this.$vs.notify({
          title: "Origenes de datos",
          text: "Seleccione el archivo",
          iconPack: "feather",
          icon: "icon-bell",
          color: "warning"
        });
      }

      this.file = this.$refs.file.files[0];

      this.$vs.loading({ type: "sound" });

      let allowPublic = false; // get from form
      let origin = "datasource";

      let metaData = {
        cacheControl: allowPublic === true ? "public" : "private",
        contentType: this.file.type,
        customMetadata: {
          lang: "es",
          origin: origin
        }
      };

      let info = {
        file: this.file,
        path: origin,
        metaData: metaData,
        public: allowPublic
      };

      this.$store
        .dispatch("firebaseStorage/uploadFile", info)
        .then(result => {
          console.info("firebase upload success:", result);

          let formData = {
            bucketPath: result.bucketPath,
            originalName: this.file.name,
            generatedName: result.generatedName,
            category: origin,
            public: allowPublic,
            metadata: metaData,
            description: this.description
          };

          Api.post("/upload", formData)
            .then(result => {
              console.info("upload success:", result);
              this.$vs.notify({
                title: "Origenes de datos",
                text: "Origen de datos en proceso de validacion",
                iconPack: "feather",
                icon: "icon-bell",
                color: "primary"
              });
            })
            .catch(result => {
              console.error("upload Error:", error);
              this.$vs.notify({
                title: "Origenes de datos",
                text: "Ocurrio un error al procesar la carga del origen de datos",
                iconPack: "feather",
                icon: "icon-bell",
                color: "warning"
              });
            });
        })
        .catch(error => {
          console.error("firebase  upload Error:", error);
          const message = error.reason ? `(${error.message})` : ".";
          this.$vs.notify({
            title: "Carga de origen de datos",
            text: `Ocurrio un error, al cargar el archivo${message}`,
            color: "warning",
            icon: "error",
            time: 6000
          });
        })
        .finally(() => {
          this.$vs.loading.close();
          this.file = undefined;
          this.$refs.file = null;
        });
    }
  }
};
</script>
